// extracted by mini-css-extract-plugin
export default {"search":"styles_search__7+Ax7","searchWrapper":"styles_searchWrapper__KTko4","icon":"styles_icon__qKo-e"};